import Box from '@mui/material/Box';
import {Typography, Button, Stack} from '@mui/material';
import Footer from '../components/Footer';
import {BookingView} from '../types';
import CancelImage from '../../../assets/svgs/cancel-icon.svg';
import CancelImageBackground from '../../../assets/svgs/cancel-icon-background.svg';
import {cancelConfirmationViewStyles} from '../styles';

interface CancelConfirmationViewProps {
  setActiveView: (view: BookingView) => void;
}

const TEXT = {
  TITLE: 'Are you sure you want to cancel your booking?',
  DESCRIPTION:
    "We're sorry to hear you want to cancel your booking. If a refund is applicable, we'll process it according to our cancellation policy. A member of our team will contact you to confirm your preferred refund method.",
  NO_BUTTON: 'No',
  YES_BUTTON: 'Yes',
  CANCEL_BACKGROUND_ALT: 'Cancel background',
  CANCEL_ICON_ALT: 'Cancel icon',
};

const CancelConfirmationView = ({
  setActiveView,
}: CancelConfirmationViewProps) => {
  const handleBackClick = () => {
    setActiveView(BookingView.AppSummaryView);
  };

  const handleContinueClick = () => {
    setActiveView(BookingView.CancelFormView);
  };

  return (
    <>
      <Box sx={cancelConfirmationViewStyles.container}>
        <Box sx={cancelConfirmationViewStyles.contentBox}>
          <Box sx={cancelConfirmationViewStyles.imageContainer}>
            <Box
              component="img"
              src={CancelImageBackground}
              alt={TEXT.CANCEL_BACKGROUND_ALT}
              sx={cancelConfirmationViewStyles.backgroundImage}
            />
            <Box
              component="img"
              src={CancelImage}
              alt={TEXT.CANCEL_ICON_ALT}
              sx={cancelConfirmationViewStyles.cancelIcon}
            />
          </Box>

          <Typography variant="h5" sx={cancelConfirmationViewStyles.titleText}>
            {TEXT.TITLE}
          </Typography>
          <Typography
            variant="body2"
            sx={cancelConfirmationViewStyles.descriptionText}
          >
            {TEXT.DESCRIPTION}
          </Typography>

          <Stack sx={cancelConfirmationViewStyles.buttonStack}>
            <Button
              variant="outlined"
              fullWidth
              sx={cancelConfirmationViewStyles.button}
              onClick={handleBackClick}
            >
              {TEXT.NO_BUTTON}
            </Button>
            <Button
              variant="contained"
              fullWidth
              sx={cancelConfirmationViewStyles.button}
              onClick={handleContinueClick}
            >
              {TEXT.YES_BUTTON}
            </Button>
          </Stack>
        </Box>
      </Box>
      <Box sx={cancelConfirmationViewStyles.footerContainer}>
        <Footer disableContinue={true} />
      </Box>
    </>
  );
};

export default CancelConfirmationView;
